// extracted by mini-css-extract-plugin
export var deleteModal = "_sc-0";